import { render, staticRenderFns } from "./VehicleStatusPreOrderHistory.vue?vue&type=template&id=0b6ea801&scoped=true"
import script from "./VehicleStatusPreOrderHistory.vue?vue&type=script&lang=js"
export * from "./VehicleStatusPreOrderHistory.vue?vue&type=script&lang=js"
import style0 from "./VehicleStatusPreOrderHistory.vue?vue&type=style&index=0&id=0b6ea801&prod&scoped=true&lang=css"
import style1 from "./VehicleStatusPreOrderHistory.vue?vue&type=style&index=1&id=0b6ea801&prod&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ea801",
  null
  
)

export default component.exports